export class SyndicateVM {
  syndicateName = "";
  totalLinesPerWeek = null;
  createdOn = new Date();
  nextDrawDate = new Date();
  syndicateType = "";
  activeStatus = "";
  nextResumeDate = new Date();
  syndicateStatus = "";
  nextDrawStatus = "N/A";

  constructor(syndicate: any) {
    this.syndicateName = syndicate?.syndicate_name ? syndicate?.syndicate_name : syndicate?.ps_name;
    this.totalLinesPerWeek = syndicate.products ? this.getPSLines(syndicate.products) : "Not available";
    this.createdOn = syndicate?.creation_date;
    this.nextDrawDate = syndicate?.next_draw_date;
    this.syndicateType = syndicate?.syndicate_type;
    this.activeStatus = (syndicate?.active_status==='ended' && syndicate?.syndicate_type==='Ongoing')?'Stopped':syndicate?.active_status;
    this.nextResumeDate = syndicate?.next_resume_date;
    this.syndicateStatus =
      syndicate?.cardType?.toLowerCase() === "managed"
        ? syndicate?.syndicate_status
          ? syndicate?.syndicate_status
          : syndicate?.status
        : syndicate?.active_status;
    this.nextDrawStatus = syndicate.next_draw_status;
  }

  getPSLines(products) {
    let count = 0;
    if (products) {
      products?.map((product) => {
        count += product.total_lines;
      });
    }

    return count;
  }
}
